var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 5.7V8.40373C7.50208 8.41011 7.05704 8.42737 6.67222 8.47392C6.0167 8.55325 5.38835 8.73212 4.87869 9.19081C4.36902 9.64951 4.17028 10.215 4.08215 10.805C3.99991 11.3555 3.99995 12.0429 4 12.8408V16.5592C3.99995 17.3571 3.99991 18.0445 4.08215 18.595C4.17028 19.185 4.36902 19.7505 4.87869 20.2092C5.38835 20.6679 6.0167 20.8467 6.67222 20.9261C7.28387 21.0001 8.0477 21.0001 8.93417 21H15.0659C15.9523 21.0001 16.7161 21.0001 17.3278 20.9261C17.9833 20.8467 18.6117 20.6679 19.1213 20.2092C19.631 19.7505 19.8297 19.185 19.9179 18.595C20.0001 18.0445 20.0001 17.3571 20 16.5592V12.8408C20.0001 12.0429 20.0001 11.3555 19.9179 10.805C19.8297 10.215 19.631 9.64951 19.1213 9.19081C18.6117 8.73212 17.9833 8.55325 17.3278 8.47393C16.943 8.42737 16.4979 8.41011 16 8.40373V5.7C16 4.20883 14.6569 3 13 3H11C9.34316 3 8.00001 4.20883 8.00001 5.7ZM11 4.8C10.4477 4.8 10 5.20295 10 5.7V8.4H14V5.7C14 5.20295 13.5523 4.8 13 4.8H11ZM12 12.9C10.8954 12.9 10 13.7059 10 14.7C10 15.6941 10.8954 16.5 12 16.5C13.1046 16.5 14 15.6941 14 14.7C14 13.7059 13.1046 12.9 12 12.9Z",
    fill: "url(#paint0_linear_2050_11277)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2050_11277",
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37B06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60C848"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockGreen);
export default __webpack_public_path__ + "static/media/lockGreen.5785c24801e72cc8d48276923aa66ce5.svg";
export { ForwardRef as ReactComponent };